import React from "react";
import { useParams } from "react-router-dom";

import { DPP_PARTNERS } from "@/constants/Partners";
import { useAppContext } from "@/contexts";
import { getDisplayName } from "@/models";

import { BaseSideForm } from "../enrollment/BaseSideForm";

import { PasscodeInputForm } from "./PasscodeInputForm";
import { UpidInputForm } from "./UpidInputForm";

export const CodeInputForm = () => {
  const { partnerInfo } = useAppContext();
  const { employerSlug } = useParams<AppParams>();

  const isPasscodeEnrollment = !!partnerInfo?.configs?.ENROLL_PASSCODE;
  const isUpidEnrollment = !!partnerInfo?.configs?.ENROLL_UPID;
  const isVpSponsor = !!partnerInfo?.configs?.ENROLL_VIRGIN_PULSE;
  const displayName = getDisplayName(partnerInfo);

  // Partners without Passcode or Virgin Pulse enrollment are typically
  // using UPID enrollment but for the edge case when none are selected
  // it's suitable to use the same messaging as UPID enrollment.
  const enrollmentBlurb =
    displayName && !isPasscodeEnrollment && !isVpSponsor && !isUpidEnrollment
      ? `Contact ${displayName} for enrollment information.`
      : "Sign up below to get started.";

  let helperText;
  if (partnerInfo?.id && DPP_PARTNERS.includes(partnerInfo.id)) {
    helperText = `Join Noom at no cost to you as a benefit from ${displayName}! Create a Noom account below to get started.`;
  } else if (partnerInfo?.configs?.HIDE_COST) {
    helperText = enrollmentBlurb;
  } else {
    helperText = `Join Noom at no cost to you! ${enrollmentBlurb}`;
  }

  return (
    <BaseSideForm helperText={helperText}>
      {employerSlug && (isPasscodeEnrollment || isVpSponsor) ? (
        <PasscodeInputForm />
      ) : (
        <UpidInputForm />
      )}
    </BaseSideForm>
  );
};
